// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rt8UUkIb90erUZ {
  position: relative;
  width: 768px;
  height: 512px;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  border-radius: var(--ds-border-radius-100, 3px);
  background-attachment: scroll;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  background-size: contain;
  background-position-x: right;
  background-position-y: top;
}
.rt8UUkIb90erUZ > div {
  height: 100%;
}
._meityA20arLse {
  position: absolute;
  z-index: 1;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
}
._meityA20arLse .cCPHbmvnLNIbxN {
  margin: var(--ds-space-075, 6px);
}
.IfAl9ohAqIb3iC {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin-right: 50%;
  padding-left: var(--ds-space-400, 32px);
  overflow-y: auto;
}
.FuwftmHOJG_O9E {
  padding-bottom: var(--ds-space-200, 16px);
}
.ZNrG4T9VI0H04y {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin: var(--ds-space-0, 0);
  overflow: hidden;
  font-weight: var(--ds-font-weight-medium, 500);
  text-overflow: ellipsis;
}
.l__UPWttOW0crR {
  flex-wrap: wrap;
  justify-content: center;
  margin: var(--ds-space-250, 20px) var(--ds-space-150, 10px) var(--ds-space-500, 40px);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding-left: 1em;
  list-style: disc;
}
.l__UPWttOW0crR li {
  margin: var(--ds-space-200, 16px) var(--ds-space-0, 0);
}
.yRdWo8t7XO8Vnu {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  max-width: 50%;
}
.xT9rL2fVknZBeY {
  display: none;
}
@media only screen and (max-width: 750px) {
  .rt8UUkIb90erUZ {
    width: 510px;
    max-width: 100vw;
    height: auto;
    min-height: 512px;
    padding: var(--ds-space-0, 0);
    /* stylelint-disable-next-line declaration-no-important */
    background-image: none !important;
  }
  .rt8UUkIb90erUZ > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: var(--ds-space-0, 0) !important;
  }
  .IfAl9ohAqIb3iC {
    display: block;
    margin-right: var(--ds-space-0, 0);
    /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
    padding: 36px var(--ds-space-300, 24px);
  }
  .IfAl9ohAqIb3iC {
    margin-right: var(--ds-space-0, 0);
  }
  .aCyjoll9Ejceb0 {
    width: 100%;
    min-width: 375px;
  }
  .yRdWo8t7XO8Vnu {
    display: none;
  }
  .xT9rL2fVknZBeY {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    overflow: hidden;
  }
}
`, ""]);
// Exports
export var dialog = `rt8UUkIb90erUZ`;
export var controls = `_meityA20arLse`;
export var closeButton = `cCPHbmvnLNIbxN`;
export var content = `IfAl9ohAqIb3iC`;
export var header = `FuwftmHOJG_O9E`;
export var title = `ZNrG4T9VI0H04y`;
export var managedAccountContent = `l__UPWttOW0crR`;
export var illustrationFull = `yRdWo8t7XO8Vnu`;
export var illustrationMobile = `xT9rL2fVknZBeY`;
export var illustration = `aCyjoll9Ejceb0`;
export default ___CSS_LOADER_EXPORT___;
